import React from 'react';
import PropTypes from 'prop-types';
import ButtonComponent from '../button';
import BadgeComponent from '../badge'; // adjust path to your actual BadgeComponent location
import { CardSecondary, CardSecondaryContent, CardSecondaryHead  } from './card-secondary.style';

const CardSecondaryComponent = ({ label, data, handleClick, hideButton, showBadge, badgeLabel, badgeType }) => {
    const renderValue = (value) => {
        if (value === null || value === undefined) return 'null';
        if (React.isValidElement(value)) return value;
        return String(value);
    };

    return (
        <CardSecondary>
            {/* HEAD */}
                <CardSecondaryHead>
                    <div className="left">
                    <h5>{label}</h5>
                </div>
                <div className="right">
                    {showBadge && <BadgeComponent label={badgeLabel || 'New'} type={badgeType || 'info'} />}
                </div>
                {
                    !hideButton &&
                    <div className="right">
                        <ButtonComponent label="Detailed view" size="small" outline onClick={handleClick} />
                    </div>
                }
                </CardSecondaryHead>    
            

            {/* BODY */}
            {
                data && Object.entries(data).length > 0 && (
                    <CardSecondaryContent valueCount={Object.entries(data).length}>
                        {
                            Object.entries(data)
                                .slice(0, 6)
                                .map(([key, value]) => (
                                    <p key={key}>
                                        <strong>{key}:</strong>{' '}
                                        {
                                            key === 'Risk Decision' ? (
                                                <BadgeComponent
                                                    label={value}
                                                    type={value === 'CHALLENGE' ? 'error' : 'success'}
                                                />
                                            ) : (
                                                renderValue(value)
                                            )
                                        }
                                    </p>
                                ))
                        }
                    </CardSecondaryContent>
                )
            }
        </CardSecondary>
    );
};

CardSecondaryComponent.propTypes = {
    label: PropTypes.string,
    data: PropTypes.object,
    handleClick: PropTypes.func,
    hideButton: PropTypes.bool,
    showBadge: PropTypes.bool,
    badgeLabel: PropTypes.string,
    badgeType: PropTypes.string,
};

export default CardSecondaryComponent;